'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidNotificationsNone = function IoAndroidNotificationsNone(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 9.4h-0.1c-0.5 0-1.9 0.4-1.9 0.4-3.6 0.7-6.1 4.1-6.1 7.8v9.9l-0.7 0.8-0.6 0.6h18.7l-0.6-0.6-0.7-0.8v-9.9c0-3.7-2.5-7.1-6.1-7.8 0 0-1.3-0.4-1.9-0.4z m0-5.6c1.4 0 2.4 1 2.4 2.4v1.1c4.6 1.1 8.1 5.4 8.1 10.3v8.9l3.2 3.3v1.6h-27.5v-1.6l3.2-3.3v-8.9c0-4.9 3.5-9.2 8.1-10.3v-1.1c0-1.4 1-2.5 2.5-2.5z m3.2 29.2c0 1.8-1.5 3.3-3.2 3.3s-3.3-1.5-3.3-3.3h6.5z' })
        )
    );
};

exports.default = IoAndroidNotificationsNone;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-notifications-none.js
// module id = 2365
// module chunks = 168707334958949